<template>
  <v-container>
    <perseu-card title="Agrupamentos de Pares">
      <v-btn color="secondary" slot="title-right" @click="create">
        Novo Agrupamento
      </v-btn>
      <v-flex slot="content">
        <filters-panel class="mb-3">
          <v-row>
            <v-col cols="12" md="2">
              <v-switch v-model="query.active" label="Ativos"></v-switch>
            </v-col>
            <v-col cols="6" md="5">
              <v-text-field
                v-model="query.name"
                label="Nome"
                @keyup.enter.native="list"
              />
            </v-col>
            <v-col cols="6" md="5">
              <types-select label="Tipo" v-model="query.type" />
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-btn color="secondary" @click="list"> Buscar </v-btn>
          </v-row>
        </filters-panel>
        <v-data-table
          :items="aggregations"
          :headers="headers"
          class="elevation-1"
          :sort-by="sortBy"
          :sort-desc="sortDesc"
        >
          <template v-slot:item.actions="props">
            <v-btn small icon @click="edit(props.item)" color="secondary">
              <v-icon small>edit</v-icon>
            </v-btn>
            <v-btn
              small
              icon
              v-if="props.item.active"
              @click="activeOrDeactivate(props.item, false)"
              color="secondary"
            >
              <v-icon small>delete</v-icon>
            </v-btn>
            <v-btn
              small
              v-else
              icon
              @click="activeOrDeactivate(props.item, true)"
              color="secondary"
            >
              <v-icon small>check</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-flex>
    </perseu-card>
    <v-dialog v-model="dialog" v-if="dialog" width="600px">
      <form-aggregations
        :aggregation="aggregation"
        @create="addToList"
        @update="updatedForm"
      ></form-aggregations>
    </v-dialog>
  </v-container>
</template>

<script>
import { find, update } from "@/services/aggregations-service";

export default {
  components: {
    "types-select": () => import("@/components/Types/Select"),
    "form-aggregations": () => import("@/components/Aggregation/Form"),
  },
  data: () => ({
    headers: [
      { text: "Nome", value: "name" },
      { text: "Tipo", value: "type.name" },
      {
        text: "Ações",
        value: "actions",
        sortable: false,
        align: "start",
        width: 200,
      },
    ],
    aggregations: [],
    aggregation: {},
    dialog: false,
    query: {
      active: true,
      name: "",
      typeId: null,
    },
    // Adicione as propriedades para ordenação padrão
    sortBy: ['type.name', 'name'],
    sortDesc: [false, false],
  }),
  created() {
    this.list();
  },
  methods: {
    async list() {
      try {
        this.$store.dispatch("loading/openDialog");

        const payload = {
          active: this.query.active,
          name: this.query.name,
          typeId: this.query.type?.id,
        }

        let response = await find(payload);
        this.aggregations = response.data;
      } catch (e) {
        this.$errorHandler(e);
      } finally {
        this.$store.dispatch("loading/closeDialog");
      }
    },
    create() {
      this.aggregation = {};
      this.dialog = true;
    },
    edit(obj) {
      this.aggregation = obj;
      this.dialog = true;
    },
    async activeOrDeactivate(item, target) {
      try {
        this.$store.dispatch("loading/openDialog");
        item.active = target;
        await update(item);
        this.removeFromList(item);
      } catch (error) {
        this.$errorHandler(error);
      } finally {
        this.$store.dispatch("loading/closeDialog");
      }
    },
    removeFromList(aggregation) {
      let index = this.aggregations.indexOf(aggregation);
      this.aggregations.splice(index, 1);
    },
    addToList(createdCategory) {
      this.aggregations.push(createdCategory);
      this.dialog = false;
    },
    updatedForm() {
      this.dialog = false;
    },
  },
};
</script>

<style></style>
